export var SubscriberPackageKey;
(function (SubscriberPackageKey) {
    SubscriberPackageKey["ANON"] = "anon";
    SubscriberPackageKey["ESB"] = "esb";
    SubscriberPackageKey["SB"] = "sb";
    SubscriberPackageKey["SSB"] = "ssb";
    SubscriberPackageKey["TSB"] = "tsb";
    SubscriberPackageKey["TVE"] = "tve";
})(SubscriberPackageKey || (SubscriberPackageKey = {}));
